import { Link } from "react-router-dom";
import { MapPin, Phone, ArrowUpRight } from "lucide-react";
import { studio } from "@/data/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-900 text-slate-300 mt-24"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-serif text-3xl text-white">Studio Cecconato</div>
          <div className="overline mt-2 text-amber-400">
            Geom. Michele · {studio.albo}
          </div>
          <p className="mt-6 text-sm leading-relaxed text-slate-400 max-w-md">
            Studio tecnico di progettazione, consulenza e rilievi topografici
            con esperienza trentennale nel triveneto e in particolare nella
            provincia di Treviso.
          </p>
        </div>

        <div>
          <h4 className="font-serif text-lg text-white mb-4">Contatti</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="mt-0.5 text-amber-400 shrink-0" />
              <span>{studio.address}</span>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={16} className="mt-0.5 text-amber-400 shrink-0" />
              <a href={studio.phoneHref} className="hover:text-white" data-testid="footer-phone">
                {studio.phone}
              </a>
            </li>
            <li>
              <Link
                to="/contatti"
                data-testid="footer-contact-link"
                className="inline-flex items-center gap-2 mt-2 text-amber-300 hover:text-amber-200 border-b border-amber-300/40 pb-0.5"
              >
                Scrivici dal modulo <ArrowUpRight size={14} />
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg text-white mb-4">Naviga</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-white">Home</Link></li>
            <li><Link to="/chi-siamo" className="hover:text-white">Chi Siamo</Link></li>
            <li><Link to="/servizi" className="hover:text-white">Servizi</Link></li>
            <li><Link to="/strumentazione" className="hover:text-white">Strumentazione</Link></li>
            <li><Link to="/lavori" className="hover:text-white">Lavori</Link></li>
            <li><Link to="/contatti" className="hover:text-white">Contatti</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Studio Tecnico Cecconato Michele</div>
          <div className="opacity-80">{studio.albo}</div>
        </div>
      </div>
    </footer>
  );
}
